/* global axios */
import ApiClient from './ApiClient';

class AgentStudioAPI extends ApiClient {
  constructor() {
    super('agent_studio', { accountScoped: true });
  }

  fetchWorkflows(workspaceId = null) {
    const url = workspaceId
      ? `${this.url}/workflows?workspace_id=${workspaceId}`
      : `${this.url}/workflows`;
    return axios.get(url);
  }

  fetchWorkflow(workflowId) {
    return axios.get(`${this.url}/workflows/${workflowId}`);
  }

  fetchWorkspaces() {
    return axios.get(`${this.url}/workflows/workspaces`);
  }

  // Settings API
  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  sync() {
    return axios.post(`${this.url}/settings/sync`);
  }
}

export default new AgentStudioAPI();
